// noinspection JSUnresolvedVariable

const Swal = require('sweetalert2');

/**
 * @param title
 * @param text
 * @param {Swal.SweetAlertOptions} config
 * @returns {*}
 */
export function successAlert(title, text, config)
{
	config = config || {};
	config.icon = 'success';
	config.title = title;
	config.text = text;
	return Swal.fire(config);
}

/**
 * @param title
 * @param text
 * @param {Swal.SweetAlertOptions} config
 * @returns {*}
 */
export function warningAlert(title, text, config)
{
	config = config || {};
	config.icon = 'warning';
	config.title = title;
	config.text = text;
	return Swal.fire(config);
}

/**
 * @param title
 * @param text
 * @param {Swal.SweetAlertOptions} config
 * @returns {*}
 */
export function errorAlert(title, text, config)
{
	config = config || {};
	config.icon = 'error';
	config.title = title;
	config.text = text;
	return Swal.fire(config);
}

/**
 * @param title
 * @param text
 * @param confirmButton
 * @param cancelButton
 * @param {Swal.SweetAlertOptions} config
 * @returns {*}
 */
export function confirmAlert(title, text, confirmButton, cancelButton, config)
{
	config = config || {};
	config.icon = config.icon || 'question';
	config.title = title;
	config.text = text;
	config.allowEscapeKey = false;
	config.allowOutsideClick = false;
	config.showConfirmButton = true;
	config.showCancelButton = true;
	config.confirmButtonText = confirmButton || 'Yes';
	config.cancelButtonText = cancelButton || 'No';

	return new Promise((resolve) =>
	{
		Swal.fire(config).then((result) =>
		{
			resolve(result && result.isConfirmed);
		});
	});
}

window.successAlert = successAlert;
window.warningAlert = warningAlert;
window.errorAlert = errorAlert;
window.confirmAlert = confirmAlert;
